/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  Homepage
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Homepage
 */
export const homepage = (

 signal?: AbortSignal
) => {


      return axiosClient<Homepage>(
      {url: `/homepage`, method: 'GET', signal
    },
      );
    }




export const getHomepageQueryKey = () => {
    return [
    'homepage'
    ] as const;
    }


export const getHomepageQueryOptions = <TData = Awaited<ReturnType<typeof homepage>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof homepage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHomepageQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof homepage>>> = ({ signal }) => homepage(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof homepage>>, TError, TData>
}

export type HomepageQueryResult = NonNullable<Awaited<ReturnType<typeof homepage>>>
export type HomepageQueryError = ErrorType<unknown>


/**
 * @summary Homepage
 */

export function useHomepage<TData = Awaited<ReturnType<typeof homepage>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof homepage>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHomepageQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






